import { graphql, useStaticQuery } from "gatsby";

export const useSiteMetadata = () => {
    const rawSiteMetadata = useStaticQuery(graphql`
        query SiteMetadataQuery {
            allContentfulSiteMetadata {
                edges {
                    node {
                        id
                        key
                        value {
                            value
                        }
                    }
                }
            }
            allSite {
                edges {
                    node {
                        siteMetadata {
                            endpoints {
                                contact
                                demo
                                lead
                                facilityReferral
                                savingsCalculator
                                friendReferral
                                referral
                                facilitySupport
                                businessInfo
                                professionalInfo
                                csuReferral
                                postAcuteLead
                                mspSubVendor
                            }
                            recaptcha {
                                siteKey
                            }
                            shareThisKey
                            intercomKey
                        }
                    }
                }
            }
        }
    `);
    let siteMetadata = {};
    // Flatten the intrincate structure returned by the GraphQL query into an object
    rawSiteMetadata.allContentfulSiteMetadata?.edges?.forEach(({ node }) => {
        // Blank/Null values return a null top-level 'value' property
        siteMetadata[node.key] = node.value?.value;
    });
    // Also merge siteMetadata from Gatsby's config
    rawSiteMetadata.allSite.edges.forEach(
        ({
            node: {
                siteMetadata: {
                    endpoints,
                    recaptcha,
                    shareThisKey,
                    intercomKey,
                },
            },
        }) => {
            siteMetadata.endpoints = endpoints;
            siteMetadata.recaptcha = recaptcha;
            siteMetadata.shareThisKey = shareThisKey;
            siteMetadata.intercomKey = intercomKey;
        }
    );

    return siteMetadata;
};
